module.exports = __webpack_public_path__ + "img/yellow_check.b92ae724.svg";